import { call, put, delay } from "redux-saga/effects";
import { enrollmentApi } from "@services/api";
import { myTotalEnrollmentActions } from "../slices";

function* myTotalEnrollmentWorker({ payload }) {
  //   yield delay(300);
  try {
    yield put(myTotalEnrollmentActions.pending());
    const response = yield call(enrollmentApi.myTotalEnrollment, payload);
    yield put(myTotalEnrollmentActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(myTotalEnrollmentActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { myTotalEnrollmentWorker };
